export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CONFIRM_INSURANCE = "CONFIRM_INSURANCE";
